module Client.ContractPage.CostOfConstruction.CostOfConstruction

open FSharpPlus
open Client
open Feliz.Bulma
open PortalLibs.Shared
open PortalLibs.Client.Util
open ContractPageModel
open Model
open Shared
open CostOfConstructionAttachmentModal
open Feliz
open Client.ContractPage.CostOfConstruction.Expanded

let CostOfConstructionTotals =
  React.memo (
    "CostOfConstructionTotals",
    (fun (props: {| ApplicationSettings: ContractSettings
                    CostsGrouped: JobPhaseCosts list |}) ->
      
      let allCosts =props.CostsGrouped >>= (fun v -> v.Costs)

      Html.tr [
        yield Html.td []
        yield
          Html.td [
            Html.div [
              prop.style [style.textAlign.right; style.marginRight(length.px 25)]
              prop.children [
                Html.strong "TOTALS:"
              ]
            ]
          ]
        yield! Utils.totalColumns props.ApplicationSettings allCosts
      ])
  )

let CostOfConstructionView =
  React.memo (
    "CostOfConstructionView",
    (fun (props: {| Model: Model
                    ContractSettings: ContractSettings
                    IsSuperUser: bool
                    Contract: Contract
                    Dispatch: Msg -> unit |}) ->

      let costView contractSettings isSuperUser contractId model dispatch costsGrouped =
        let costsExpanded =
          Expanded.view
            contractSettings
            isSuperUser
            contractId
            props.Contract
            model.JobCostDetails
            model.ExpandedCostOfConstructionDetails
            model.SearchValues
            model.JobCostDetailAttachments
            model.TableStates
            dispatch
            props.Model.JobCostSubs

        let costsCollapsed v =
          {| AppSettings = contractSettings
             ContractId = contractId
             JobPhaseCosts = v
             Dispatch = dispatch
             Key = v.Phase.Code |}
          |> Collapsed.CostsCollapsed
          |> List.singleton
        
        React.fragment [
          Html.div [
            prop.style [style.paddingBottom(length.px 50)]
            prop.children [
              Bulma.table [
                table.isFullWidth
                table.isHoverable
                prop.style [Styles.stickyTableBorder]
                prop.children [
                  Html.thead [
                    prop.children [
                      Html.tr [
                        prop.style (Styles.sticky(zIndex = 1))
                        prop.children [
                          
                          let th styles (txt: string) (width: int option) =
                            Html.th[
                              prop.style [
                                style.verticalAlign.middle
                                if width.IsSome then style.width(length.px width.Value)
                                yield! styles
                              ]
                              prop.text txt
                            ]
                          
                          th [style.textAlign.right] "Phase Code" (Some 100)
                          th [] "Description" None
                          th [style.textAlign.right] "Earned revenue" (Some 100)
                          th [style.textAlign.right] "Orig Est Cost" (Some 100)
                          th [style.textAlign.right] "Current Est Cost" (Some 100)
                          th [style.textAlign.right] "Actual Costs To Date" (Some 130)
                          th [style.textAlign.right] "Cost To Complete" (Some 100)
                          th [style.textAlign.right] "Gross Profit" (Some 100)
                          th [style.textAlign.right; style.whitespace.nowrap] "% Margin" (Some 100)
                          if contractSettings.Projections then
                            th [style.textAlign.right; style.whitespace.nowrap] "% Estimate" (Some 110)
                            th [style.textAlign.right] "Project Mgr's Revised Cost" (Some 130)
                        ]
                      ]
                    ]
                  ]
                  Html.tbody [
                    match costsGrouped with
                    | [] ->
                      yield
                        Html.tr [
                          Html.td [
                            prop.colSpan 5
                            prop.style [ style.textAlign.center; style.padding(30, 0) ]
                            prop.text "No Job Costs"
                            ]
                        ]
                    | _ ->

                      let buildCostsForPhase v =
                        let expanded =
                          model.ExpandedCostOfConstructionPhases
                          |> Map.tryFind contractId
                          |>> (fun m -> m |> List.contains v.Phase.Code)
                          |> Option.defaultValue false

                        v |> if expanded then costsExpanded else costsCollapsed

                      yield! costsGrouped >>= buildCostsForPhase

                      if costsGrouped.Length > 1 then
                        yield
                          CostOfConstructionTotals
                            {| ApplicationSettings = contractSettings
                               CostsGrouped = costsGrouped |}
                  ]
                ]
                
              ]
            ]  
          ]
          attachmentsModal
            model.JobCostAttachmentsModalOpen
            model.JobCostDetailAttachments
            model.JobCostAttachmentPreview
            model.JobCostAttachmentDownload
            model.JobCostDetailAttachmentFiles
            model.JobCostDetailAttachmentFilesVisited
            dispatch
        ]

      props.Model.JobCosts
      |> Map.tryFind props.Contract.Id
      |> loadingMessageOrContent
           "Loading Job Costs..."
           (costView props.ContractSettings props.IsSuperUser props.Contract.Id props.Model props.Dispatch))
  )
